import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forEach } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GtmService } from '../../../../../shared/cardholders-core/services/gtm.service';
import { ModalService } from '../../../../../shared/modules/bs-modal/services/modal.service';
import { ICalculatorSection } from '../../../interfaces/ICalculatorSection.interface';
import { IStandingOrderData } from '../../../interfaces/ICheckForCardResponse.interface';
import { IContentResponse } from '../../../interfaces/IContentResponse.interface';
import { IDirectDebitBenefitDataRequest } from '../../../interfaces/IDirectDebitBenefitDataRequest.interface';
import { DirectDebitService } from '../../../services/direct-debit.service';

@Component({
    selector: 'app-calculator-popup',
    templateUrl: './calculator-popup.component.html',
    styleUrls: ['./calculator-popup.component.scss']
})
export class CalculatorPopupComponent implements OnInit {
    showErrorMsg: boolean;
    contents: IContentResponse;
    totalSumValue: number;
    sectionsData: ICalculatorSection[] = [
        {
            image: '/assets/images/direct-debit/weight.svg',
            title: 'מנוי לחדר כושר',
            subTitle: '(כל מנויי הספורט שלכם)',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/smartphone.svg',
            title: 'מנוי סלולרי',
            subTitle: '(כל מנויי הסלולר שלכם)',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/world.svg',
            title: 'אינטרנט ביתי',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/tv.svg',
            title: 'כבלים / TV / לווין',
            subTitle: '(גם נטפליקס נחשב)',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/water.svg',
            title: 'בר מים',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/musical-notes.svg',
            title: 'שירותי מוזיקה',
            subTitle: '(Spotify / אפל מיוזיק /youtube)',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/wallet.svg',
            title: 'שירותי APPLE/GOOGLE',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/globus.svg',
            title: 'מנוי פיס',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/stethoscope.svg',
            title: 'קופת חולים',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/receipt.svg',
            title: 'ביטוחים',
            subTitle: '(בריאות,בית ורכב)',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/talk-bubble.png',
            title: 'חשמל, מים ארנונה',
            subTitle: '',
            isActive: false,
            sumValue: null
        },
        {
            image: '/assets/images/direct-debit/lamp.svg',
            title: 'אחר',
            subTitle: '(כל תשלום קבוע אחר)',
            isActive: false,
            sumValue: null
        }
    ];
    s;

    constructor(
        private modalSvc: ModalService,
        public bsModalRef: BsModalRef,
        private directDebSrv: DirectDebitService,
        private gtmService: GtmService,
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.gtmService.pushDirectDebit('calculator', 'load');
        this.contents = this.directDebSrv.contents$.value;
    }
    totalSum(): number {
        this.totalSumValue = this.sectionsData
            .filter((item) => item.isActive)
            .reduce((sum, current) => sum + current.sumValue, 0);
        return this.totalSumValue;
    }
    close(): void {
        this.modalSvc.closeModal();
    }

    transferDirectDebits(): void {
        if (!this.sectionsData.some((x) => x.isActive === true)) {
            this.showErrorMsg = true;
            return;
        }

        this.gtmService.pushDirectDebit('calculator', 'continue');
        var selectedSectionsData = this.sectionsData.filter((item) => item.isActive);
        for (var section of selectedSectionsData) {
            this.gtmService.pushDirectDebit('calculator-type', section.title);
        }
        this.gtmService.pushDirectDebit('calculator-num', selectedSectionsData.length.toString());
        this.modalSvc.closeModalAndAlertSubscribers(this.totalSumValue);
    }
    isShowErrorMsg(): boolean {
        return this.showErrorMsg != null && !this.sectionsData.some((x) => x.isActive === true);
    }
}
